import { Component, OnInit, OnDestroy } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CampusWard, CampusStake, ChurchUnitsDataService, UserService, CampusUnit, CampusWardsDataService } from '../../shared';

@Component({
  templateUrl: './campus-unit-proxy.component.html',
  styleUrls: ['./campus-unit-proxy.component.scss']
})
export class CampusUnitProxyComponent implements OnInit, OnDestroy {

  loading = false;
  loadingError = false;

  proxiedUnit: CampusUnit;

  campusStakes: CampusStake[];
  _selectedCampusStake;

  /**
   * Getter for our selected campus stake.
   */
  get selectedCampusStake(): CampusStake {
    return this._selectedCampusStake;
  }

  /**
   * Setter for our selected campus stake; when we set the ward to a real ward, clear out any selected campus ward.
   */
  set selectedCampusStake(value: CampusStake) {
    this._selectedCampusStake = value;
    if (value) {
      this._selectedCampusWard = null;
    }
  }

  campusWards: CampusWard[];
  _selectedCampusWard: CampusWard;

  /**
   * Getter for our selected campus ward.
   */
  get selectedCampusWard(): CampusWard {
    return this._selectedCampusWard;
  }

  /**
   * Setter for our selected campus ward; when we set the ward to a real ward, clear out any selected campus stake.
   */
  set selectedCampusWard(value: CampusWard) {
    this._selectedCampusWard = value;
    if (value) {
      this._selectedCampusStake = null;
    }
  }

  private proxiedUnitSubscription: Subscription;

  constructor(private churchService: ChurchUnitsDataService, private wardService: CampusWardsDataService, private userService: UserService) { }

  ngOnInit() {
    this.proxiedUnitSubscription = this.userService.proxyUnit.subscribe(unit => this.proxiedUnit = unit);

    this.loading = true;
    forkJoin(
      this.wardService.getCampusWards(),
      this.churchService.getCampusStakes()
    )
    .pipe(
      finalize(() => this.loading = false)
    )
    .subscribe(
      ([campusWards, campusStakes]) => {
        this.campusWards = campusWards;
        this.campusStakes = campusStakes;
      },
      (error) => {
        this.loadingError = true
      });
  }

  ngOnDestroy() {
    this.proxiedUnitSubscription.unsubscribe();
  }

  /**
   * Sets the campus unit that the user wants to proxy for.
   */
  proxyForUnit() {
    if (this.selectedCampusStake) {
      this.userService.setProxyStake(this.selectedCampusStake);
    } else if (this.selectedCampusWard) {
      this.userService.setProxyWard(this.selectedCampusWard);
    }
  }

  /**
   * Gets the name of the unit the user's proxying for, null if none.
   */
  getProxiedUnitName(): string {
    if (this.proxiedUnit) {
      return this.proxiedUnit.name;
    }

    return null;
  }
}
